export const inputTypes = {
  numero: {
    type: 'integer',
    title: ''
  },
  deliveryDate: {
    type: 'string',
    title: '',
    format: 'date'
  }
};

export const inputUi = ['integer'];
